import { useState, useEffect, useCallback, useContext } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { LoginContext } from '../context/loginContext'
import Login from '../login/Login'
import MensajeConexion from '../mensajeConexion/MensajeConexion'
import * as categoriaScrapService from '../servicios/categoriaScrapService'

const Scraps = () => {
  const [categoriaScrap, setCategoriaScrap] = useState([])
  const navigate = useNavigate()
  const { isAuthenticated } = useContext(LoginContext)

  useEffect(() => {
    const fetchData = async () => {
      const { data: categoriaScrap } = await categoriaScrapService.buscarTodosPorScraps(1)
      setCategoriaScrap(categoriaScrap)
    }
    fetchData()
  }, [])

  const onClick = useCallback(
    (descripcion) => {
      navigate(`/scraps/${descripcion}`)
    },
    [navigate]
  )

  const mostrarMensaje = useCallback(() => {
    return (
      <div>
        <MensajeConexion />
        <Login />
      </div>
    )
  }, [])

  if (!isAuthenticated) {
    return mostrarMensaje()
  } else {
    return (
      <>
        <h4 className="mt-4">Scrap</h4>
        <div className="row">
          {categoriaScrap.map((c) => (
            <div className="col-3 item pd-20 pl-60 pr-0" key={c.idCategoria}>
              <Link
                name={c.descripcion}
                onClick={() => onClick(c.descripcion, c.esScrap)}
                className="cabecera"
              >
                {c.descripcion}
              </Link>
            </div>
          ))}
        </div>
      </>
    )
  }
}

export default Scraps
